import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';

export const ResetWarningModalBody = ({ showNote = true }) => {
  return (
    <div>
      <div className="flex flex-row gap-5 bg-[#FFEDAD] border-solid border-[1px] border-l-4 border-[#FFCA0A] py-3 pl-5 mb-3">
        <RMSvgIcon name="Warning" fill="#FFCA0A" className="" />
        <div>
          Are you sure you want to reset preferences to global values? All unsaved preferences will be lost.
        </div>
      </div>
      {showNote && (
        <span className="text-[#5D5D5D]">
          Note: Some preferences might still be overwritten by group preference values.
        </span>
      )}
    </div>
  );
};
